import * as React from 'react';
import { RelatorioFluxoMoneyCell } from '../fluxo/relatorio-fluxo-money-cell';
import { BaSeIcon, BaSeSmall1, BaSeTheme, BaSeHeading5 } from '@base/react';
import {
  MainBody,
  CardContentWrapper,
  ExternalShell,
} from '../fluxo/relatorio-fluxo-lista-styled';
import { SituacaoTags } from '../../../pages/new-relatorios/relatorios-lancamentos';
import {
  CardRightPanel,
  CellCategoriaContent,
  HeaderInfoMain,
  InfoMainAccordion,
  RightCellContent,
  RightInfoCell,
  RightInfoMain,
} from './relatorio-categoria-styled';

const DEFAULT_TEXT_COLOR = BaSeTheme.colors.institucionais.cinzaSebrae20;

export const colunasCategoria = [
  { id: 1, label: 'Categoria e subcategoria' },
  { id: 2, label: 'Situação' },
  { id: 3, label: 'Valor' },
];

const RightCell = ({ value, isTag = false }) => (
  <>
    <RightInfoCell height="46px">
      <RightCellContent>
        {isTag ? (
          <SituacaoTags value={value} />
        ) : (
          <BaSeSmall1 color={DEFAULT_TEXT_COLOR}>{value}</BaSeSmall1>
        )}
      </RightCellContent>
    </RightInfoCell>
  </>
);

export const RelatorioContegoria = ({
  dadosLancamento,
  isExpandRows,
  isBreak,
  setIsBreak,
  tipoLancamento,
}) => {
  //const { inTablet } = React.useContext(BaSeBreakpointContext);
  const [showOptions, setShowOptions] = React.useState({});

  const { azulSebrae36 } = BaSeTheme.colors.institucionais;

  const showTitleColumns = React.useMemo(
    () => (
      <>
        {colunasCategoria?.map((ele, i) => (
          <RightInfoCell height="46px" key={ele.id}>
            <RightCellContent justify={i === 0 ? 'start' : 'center'}>
              <div style={{ marginLeft: 16 }}>
                <BaSeSmall1 color={DEFAULT_TEXT_COLOR} isBold>
                  {ele?.label}
                </BaSeSmall1>
              </div>
            </RightCellContent>
          </RightInfoCell>
        ))}
      </>
    ),
    [],
  );

  const hideInfo = React.useCallback(
    (value) => {
      const currentOption = showOptions[value];
      setShowOptions((prev) => ({ ...prev, [value]: !currentOption }));
    },
    [showOptions],
  );

  const showCate = React.useCallback(
    (lancamentos, type) => {
      if (!lancamentos) {
        return;
      }

      return (
        <>
          {lancamentos?.listaLancamentos?.map((item, id) => (
            <React.Fragment key={id}>
              {showOptions[type] && (
                <>
                  <RightInfoMain height="46px">
                    <RightInfoCell height="46px">
                      <CellCategoriaContent>
                        <div style={{ marginLeft: 24 }}>
                          <BaSeSmall1 color={DEFAULT_TEXT_COLOR}>
                            {item?.descricao ?? ''}
                          </BaSeSmall1>
                        </div>
                      </CellCategoriaContent>
                    </RightInfoCell>
                    <RightInfoCell height="46px">
                      <RightCellContent justify={'center'}>
                        <SituacaoTags value={item?.situacao ?? ''} />
                      </RightCellContent>
                    </RightInfoCell>
                    <RightInfoCell height="46px">
                      <RightCellContent justify={'end'}>
                        <RelatorioFluxoMoneyCell
                          type={tipoLancamento}
                          value={item?.valorLancamento ?? 0}
                        />
                      </RightCellContent>
                    </RightInfoCell>
                  </RightInfoMain>
                </>
              )}
            </React.Fragment>
          ))}
        </>
      );
    },
    [showOptions, tipoLancamento],
  );

  const showSingleRow = React.useCallback(
    (value, tipoLancamento) => {
      return (
        <RightInfoMain height="46px">
          <RightInfoCell height="46px">
            <CellCategoriaContent>
              <BaSeSmall1 color={DEFAULT_TEXT_COLOR}>
                <InfoMainAccordion
                  hasClick
                  onClick={() => hideInfo(value?.categoria)}
                  height="46px"
                >
                  <BaSeSmall1 color={DEFAULT_TEXT_COLOR} isBold>
                    {value?.categoria ?? ''}
                  </BaSeSmall1>
                  <BaSeIcon
                    name={
                      showOptions[value?.categoria ?? 'Receita']
                        ? 'arrow-head-up'
                        : 'arrow-head-down'
                    }
                    description="Exibe/Recolhe informações de lançamentos de Receitas"
                    size={12}
                    color={azulSebrae36}
                  />
                </InfoMainAccordion>
              </BaSeSmall1>
            </CellCategoriaContent>
          </RightInfoCell>
          <RightCell value={''} />
          <RightInfoCell height="46px">
            <RightCellContent justify={'end'}>
              <RelatorioFluxoMoneyCell
                type={tipoLancamento}
                value={value?.valorTotalCategoria ?? 0}
              />
            </RightCellContent>
          </RightInfoCell>
        </RightInfoMain>
      );
    },
    [azulSebrae36, hideInfo, showOptions],
  );

  const showSubCategoriaRow = React.useCallback(
    (value, tipoLancamento) => {
      return (
        <>
          <RightInfoMain height="46px">
            <RightInfoCell height="46px">
              <CellCategoriaContent>
                <BaSeSmall1 color={DEFAULT_TEXT_COLOR}>
                  <InfoMainAccordion
                    hasClick
                    onClick={() => hideInfo(value?.subCategoria)}
                    height="46px"
                  >
                    <BaSeIcon
                      name={
                        showOptions[value?.subCategoria]
                          ? 'angle-up'
                          : 'angle-down'
                      }
                      description="Exibe/Recolhe informações de lançamentos de subcategorias"
                      size={12}
                      color={azulSebrae36}
                    />
                    <BaSeSmall1 color={DEFAULT_TEXT_COLOR}>
                      {value?.subCategoria ?? ''}
                    </BaSeSmall1>
                  </InfoMainAccordion>
                </BaSeSmall1>
              </CellCategoriaContent>
            </RightInfoCell>
            <RightCell value={''} />
            <RightInfoCell height="46px">
              <RightCellContent justify={'end'}>
                <RelatorioFluxoMoneyCell
                  type={tipoLancamento}
                  value={value?.valorSubCategoria ?? 0}
                />
              </RightCellContent>
            </RightInfoCell>
          </RightInfoMain>
        </>
      );
    },
    [azulSebrae36, hideInfo, showOptions],
  );

  const showSubCategoriaCate = React.useCallback(
    (lancamentos) => {
      if (!lancamentos) {
        return;
      }

      return (
        <>
          {lancamentos?.listaSubCategorias?.map((item, id) => (
            <React.Fragment key={id}>
              <>
                {showOptions[lancamentos?.categoria] && (
                  <>
                    <div>
                      {showSubCategoriaRow(item, dadosLancamento?.tipo)}
                    </div>
                    {showCate(item, item?.subCategoria)}
                  </>
                )}
              </>
            </React.Fragment>
          ))}
        </>
      );
    },
    [dadosLancamento, showCate, showOptions, showSubCategoriaRow],
  );

  const listRow = React.useCallback(
    (row, type, border, height, blue, last) => {
      return (
        <React.Fragment>
          {colunasCategoria?.map((item, i) => (
            <RightInfoCell
              noBorder={border}
              height={height ?? '46px'}
              blue={blue}
              key={i}
              last={last}
            >
              {i === 0 && (
                <RightCellContent justify={'start'}>
                  <BaSeSmall1 color={DEFAULT_TEXT_COLOR} isBold>
                    {`Total ${
                      dadosLancamento?.tipo === 'Receita' ? 'recebido' : 'pago'
                    }`}
                  </BaSeSmall1>
                </RightCellContent>
              )}
              {item?.label === 'Valor' && (
                <RightCellContent justify={'end'}>
                  <RelatorioFluxoMoneyCell type={type} value={row ?? 0} />
                </RightCellContent>
              )}
            </RightInfoCell>
          ))}
        </React.Fragment>
      );
    },
    [dadosLancamento],
  );

  React.useEffect(() => {
    if (!dadosLancamento?.listaCategorias && !isBreak) return;
    const categoriasShowOptions = dadosLancamento?.listaCategorias?.reduce(
      (acc, item) => {
        acc[item.categoria] = isExpandRows;
        const subCategorias = item?.listaSubCategorias ?? [];
        for (const subCategoria of subCategorias) {
          acc[subCategoria.subCategoria] = isExpandRows;
        }
        return acc;
      },
      {},
    );
    setShowOptions(categoriasShowOptions);
    setIsBreak(false);
  }, [dadosLancamento, isBreak, isExpandRows, setIsBreak]);

  return (
    <ExternalShell>
      <MainBody>
        <CardContentWrapper>
          <CardRightPanel>
            <HeaderInfoMain height="53px">
              <BaSeHeading5 isBold color={DEFAULT_TEXT_COLOR}>
                {`${dadosLancamento?.tipo}s`}
              </BaSeHeading5>
            </HeaderInfoMain>
            <RightInfoMain height="46px">{showTitleColumns}</RightInfoMain>
            {dadosLancamento?.listaCategorias?.map((item, i) => (
              <React.Fragment key={i}>
                {showSingleRow(item, dadosLancamento?.tipo)}
                {showSubCategoriaCate(item, true, dadosLancamento?.tipo)}
              </React.Fragment>
            ))}
            <RightInfoMain height="46px">
              {listRow(
                dadosLancamento?.totalPorTipo,
                'auto',
                true,
                '46px',
                true,
                true,
              )}
            </RightInfoMain>
          </CardRightPanel>
        </CardContentWrapper>
      </MainBody>
    </ExternalShell>
  );
};
